const getLangFromCulture = culture => {
  return typeof culture === 'string' && culture.length
    ? culture.split('-')[0]
    : '';
};

export default getLangFromCulture;
